import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { DropDownList } from "../Components/DropDownList";
import { CoordsButton } from "../Components/CoordsButton";
import { useEffect, useState } from "react";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
import RemoveCircleTwoToneIcon from "@mui/icons-material/RemoveCircleTwoTone";
import { UnidadMedida } from "../Components/UnidadMedida";
import {
  addEspaceCharacters,
  constantes,
  instance,
} from "../Components/config";
import { useAuth } from "../Components/AuthContext";
import { DialogAlert } from "../Components/DialogAlert";
import { useLocation } from "react-router-dom";
import { LoaderBox } from "../Components/LoaderBox";

function ActividadEditar() {
  const { state } = useLocation();
  const { id } = state;
  const [coords, setScoords] = useState();
  const [unidades, setUnidades] = useState([]);
  const [upse, setUPSE] = useState({ Id: "", Nombre: "" });
  const [responsable, setResponsable] = useState({ Id: "", Nombre: "" });
  const [catalogo, setCatalogo] = useState({ Id: "", Nombre: "" });
  const [producto, setProducto] = useState({ Id: "", Nombre: "" });
  const [departamento, setDepartamento] = useState({ Id: "", Nombre: "" });
  const [municipio, setMunicipio] = useState({ Id: "", Nombre: "" });
  const [openDialog, setOpenDialog] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [actividad, setActividad] = useState({});
  const { user } = useAuth();
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
    redirect: false,
    page: "/Actividad",
    pageState: {},
  });

  if (isLoading) {
    instance
      .get(`/actividad/getById/${id}`)
      .then((res) => {
        const { data } = res;
        setUnidades(
          data.unidades.split(";|||//|||;").map((item) => {
            const unidad = item.split(";//|||//;");
            return {
              categoria: unidad[0],
              unidad: unidad[1],
              cantidad: unidad[2],
              categoriaId: unidad[3],
              unidadId: unidad[4],
            };
          })
        );
        setActividad(data);
        setUPSE({ Id: data.upseId, Nombre: "" });
        setCatalogo({ Id: data.catalogoId, Nombre: "" });
        setProducto({ Id: data.productoId, Nombre: "" });
        setDepartamento({ Id: data.departamentoId, Nombre: "" });
        setMunicipio({ Id: data.municipioId, Nombre: "" });
        setResponsable({ Id: data.responsableId, Nombre: "" });
        setScoords(data.coordenadas);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally(
        setTimeout(() => {
          setLoading(false);
        }, 1000)
      );
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setActividad({ ...actividad, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    let form = {
      actividad: id,
      id: user.id,
      upse: upse.Id === "" ? actividad.upseId : upse.Id,
      responsable:
        responsable.Id === "" ? actividad.responsableId : responsable.Id,
      descripcion: addEspaceCharacters(info.descripcion.value),
      resultado: addEspaceCharacters(info.resultado.value),
      municipio: municipio.Id === "" ? actividad.municipioId : municipio.Id,
      producto: producto.Id === "" ? actividad.productoId : producto.Id,
      localidad: addEspaceCharacters(info.localidad.value),
      coordenadas: addEspaceCharacters(info.coordenadas.value),
      meta: addEspaceCharacters(info.meta.value),
      aprobado: info.aprobado.value,
      catalogo: catalogo.Id === "" ? actividad.catalogoId : catalogo.Id,
      unidades: unidades,
    };
    instance
      .put("actividad/", form)
      .then((res) => {
        setDialog({
          title: "Operación exitosa",
          text: "La actividad ha sido actualizada exitosamente.",
          redirect: true,
          page: "/Actividad",
          pageState: { id: id },
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        maxWidth="lg"
        sx={{ border: { xs: "0", sm: "1px solid #000" }, mt: 2 }}
        component="form"
        onSubmit={handleSubmit}
      >
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={3} padding={2} rowSpacing={1}>
              <Grid item xs={12}>
                <DropDownList
                  required
                  title="UPSE"
                  endpoint={"/upse/listActiveAndActual/" + actividad.upseId}
                  selectedItem={upse}
                  setSelectedItem={setUPSE}
                  selected={actividad.upseId}
                />
              </Grid>
              <Grid item xs={12}>
                <DropDownList
                  required
                  title="Responsable"
                  endpoint={
                    "/users/listActiveAndActual/" + actividad.responsableId
                  }
                  selectedItem={responsable}
                  setSelectedItem={setResponsable}
                  selected={actividad.responsableId}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="descripcion"
                  label="Descripción"
                  name="descripcion"
                  inputProps={{ maxLength: 500 }}
                  multiline
                  rows={4}
                  value={actividad.descripcion}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DropDownList
                  required
                  title="Departamento"
                  endpoint={"/localidad/listActiveDepartamento"}
                  selectedItem={departamento}
                  setSelectedItem={setDepartamento}
                  selected={actividad.departamentoId}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DropDownList
                  required
                  title="Municipio"
                  endpoint={
                    departamento.Id !== ""
                      ? `/localidad/listActiveMunicipio/${departamento.Id}`
                      : undefined
                  }
                  selectedItem={municipio}
                  setSelectedItem={setMunicipio}
                  disabled={departamento.Id === ""}
                  hierarchyUpdated={departamento}
                  selected={actividad.municipioId}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="coordenadas"
                  label="Coordenadas"
                  name="coordenadas"
                  inputProps={{ maxLength: 150 }}
                  value={coords}
                  onChange={(e) => setScoords(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
                <CoordsButton
                  title="Obtener ubicación actual"
                  color="primary"
                  output={setScoords}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="aprobado"
                  label="Presupuesto Aprobado"
                  name="aprobado"
                  type="number"
                  inputProps={{
                    step: constantes.decimales_dinero,
                    min: 0,
                    style: { textAlign: "right" },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">Q</InputAdornment>
                    ),
                  }}
                  value={actividad.aprobado}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="localidad"
                  label="Localidad"
                  name="localidad"
                  inputProps={{ maxLength: 200 }}
                  multiline
                  value={actividad.localidad}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="meta"
                  label="Meta según PEI"
                  inputProps={{ maxLength: 100 }}
                  name="meta"
                  multiline
                  value={actividad.meta}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="resultado"
                  label="Resultado esperado"
                  inputProps={{ maxLength: 500 }}
                  name="resultado"
                  multiline
                  value={actividad.resultado}
                  onChange={handleInputChange}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={3} padding={2} rowSpacing={1}>
              <Grid item xs={12} sm={6}>
                <DropDownList
                  required
                  title="Catálogo"
                  endpoint={
                    "/catalogo/listActiveAndActual/" + actividad.catalogoId
                  }
                  selectedItem={catalogo}
                  setSelectedItem={setCatalogo}
                  selected={actividad.catalogoId}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DropDownList
                  required
                  title="Producto"
                  endpoint={
                    catalogo.Id !== ""
                      ? `/producto/listActiveAndActual/${catalogo.Id}/${actividad.productoId}`
                      : undefined
                  }
                  selectedItem={producto}
                  setSelectedItem={setProducto}
                  disabled={catalogo.Id === ""}
                  hierarchyUpdated={catalogo}
                  selected={actividad.productoId}
                />
              </Grid>
              <Grid item xs={12}>
                <Box
                  sx={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}
                  padding={1}
                >
                  {unidades.map((unidad, index) => {
                    return (
                      <>
                        <Grid
                          container
                          sx={{ display: "flex", flexDirection: "row" }}
                        >
                          <Grid item xs={6}>
                            <Typography variant="h6">
                              <b>Categoría: </b>
                              {unidad.categoria}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="h6">
                              <b>Unidad: </b>
                              {unidad.unidad}
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              type="number"
                              margin="normal"
                              required
                              fullWidth
                              label="Cantidad"
                              inputProps={{
                                step: constantes.decimales_unidades,
                                min: 0,
                                style: { textAlign: "right" },
                              }}
                              defaultValue={unidad.cantidad}
                              onChange={(e) =>
                                (unidades[index] = {
                                  ...unidades[index],
                                  cantidad: e.target.value,
                                })
                              }
                            />
                          </Grid>
                        </Grid>
                        <Divider />
                      </>
                    );
                  })}
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Box>
              <Button
                type="submit"
                variant="contained"
                color="success"
                sx={{ mb: 2 }}
                padding={1}
              >
                Actualizar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { ActividadEditar };
